/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOut } from './CarveOut';
import {
    CarveOutFromJSON,
    CarveOutFromJSONTyped,
    CarveOutToJSON,
    CarveOutToJSONTyped,
} from './CarveOut';

/**
 * 
 * @export
 * @interface CarveOutListResponse
 */
export interface CarveOutListResponse {
    /**
     * 
     */
    data: Array<CarveOut>;
    /**
     * Sum of cost_per_day across carve-outs currently selected for submission.
     */
    total_cost_per_day: number;
    /**
     * 
     */
    incomplete_count: number;
}

/**
 * Check if a given object implements the CarveOutListResponse interface.
 */
export function instanceOfCarveOutListResponse(value: object): value is CarveOutListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total_cost_per_day' in value) || value['total_cost_per_day'] === undefined) return false;
    if (!('incomplete_count' in value) || value['incomplete_count'] === undefined) return false;
    return true;
}

export function CarveOutListResponseFromJSON(json: any): CarveOutListResponse {
    return CarveOutListResponseFromJSONTyped(json, false);
}

export function CarveOutListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CarveOutFromJSON)),
        'total_cost_per_day': json['total_cost_per_day'],
        'incomplete_count': json['incomplete_count'],
    };
}

export function CarveOutListResponseToJSON(json: any): CarveOutListResponse {
    return CarveOutListResponseToJSONTyped(json, false);
}

export function CarveOutListResponseToJSONTyped(value?: CarveOutListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CarveOutToJSON)),
        'total_cost_per_day': value['total_cost_per_day'],
        'incomplete_count': value['incomplete_count'],
    };
}

